export type AccountRole = 'ADMIN' | 'MANAGER' | 'USER'
export type WorkspaceRole = 'MANAGER' | 'LEAD' | 'REVIEWER' | 'AGENT'

export const ACCOUNT_ROLE_OPTIONS: AccountRole[] = ['ADMIN', 'MANAGER', 'USER']
export const WORKSPACE_ROLE_OPTIONS: WorkspaceRole[] = ['MANAGER', 'LEAD', 'REVIEWER', 'AGENT']
